import { fork, put, select, takeLatest } from "redux-saga/effects";

import ApiClient from "../../../api/ApiClient";
import ChangeMarketsSettingsEvent from "../../../lib/SalesManago/events/ChangeMarketsSettingsEvent";
import { actions as alertsActions } from "../alerts";
import { trackSMEvent } from "../salesManagoEventTracker";
import { getUserMarkets, toggleMarket } from "./index";
import { getUserMarketsState } from "./selector";
import decisionModal from "../../../lib/decisionModal";

function* onGetUserMarkets() {
  try {
    const { data } = yield ApiClient.get("app.auth.markets");

    yield put(getUserMarkets.success({ data: data.message }));
  } catch (error) {
    console.log(error);
  }
}

function* onToggleMarket({ payload }) {
  const { markets } = yield select(getUserMarketsState);
  const { market } = payload;

  if (!markets) {
    return;
  }

  let newMarkets = [...markets];
  let marketToToggleIndex = newMarkets.findIndex(element => element === market);

  if (marketToToggleIndex !== -1) {
    newMarkets.splice(marketToToggleIndex, 1);
  } else {
    newMarkets.push(market);
  }

  let decision = "";

  if (marketToToggleIndex !== -1) {
    decision = yield decisionModal(
      "ConfirmModal",
      {
        title: "market-unfollow_title",
        message: "market-unfollow_description"
      },
      ["confirm", "cancel"],
      {
        confirm: "market-unfollow_button"
      }
    );
  }

  if (decision === "cancel") {
    return;
  }

  try {
    yield ApiClient.put({
      urlPath: "app.auth.markets",
      data: {
        value: newMarkets
      }
    });
    const smEvent = new ChangeMarketsSettingsEvent(payload);
    yield put(trackSMEvent(smEvent));

    yield put(
      alertsActions.addSuccessAlert({
        title: "Changes saved"
      })
    );
    yield put(toggleMarket.success({ data: newMarkets }));
  } catch (error) {
    console.error(error);
    yield put(toggleMarket.failure());
  }
}

function* watchGetUserMarkets() {
  yield takeLatest(getUserMarkets.TRIGGER, onGetUserMarkets);
  yield takeLatest(toggleMarket.TRIGGER, onToggleMarket);
}

export default [fork(watchGetUserMarkets)];
